module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAZCAYAAADAHFVeAAAACXBIWXMAAAsSAAALEgHS3X78AAABR0lEQVRIx72WMW6DMBSGP1B2kGCBKTcoN2g6e0lPEHqTHiE3SHKCLLDTG8AN0sWTBziBO9RULQXcSHafxGDzS5/e+63fDqokK4ETn9UBe6HkDQ8VTtYPQFun+dYLTCh5FkoGwBMwABFQ+IAFWuuvRZ3mDfBooCXQu4AIJRuAzWR/hEXA1VVHdZpfhJLlFOblYACHOs3b6QFp8VfxD89My9oT7Dmc2ew8wfo5mBffhJLNHMyHb8NcgozH33W1S7Dbv8E8hXC/1BnAm2O/zmswV911wG6c1mZlxgfgHSiEkk4COVwzFIgBZ3fbr7gykRWbUUYORtivdmYEO+fRpbVe/aoki6sk29t0RlusaUPLpRebRLnWaV5atIVNG1oaL80jCOBkeQi9fvP4eDdMKHkELmb5YkmX0ng8GL/v92z04o+6uEqy7dL/D80I9+ju24RQAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cart.png
// module id = mduu
// module chunks = 1